export default __webpack_public_path__ + "static/media/debit-card.7025c8a2.svg";